// import { useState, useEffect } from 'react';
// import '../Assests/Leave_request.css';
// import { getLeaves, getLeavesByProfile, updateLeave } from '../Db_Connections/leavesApi';

// export default function LeaveRequests() {
//   const [requests, setRequests] = useState([]);
//   const [statusFilter, setStatusFilter] = useState('Pending');
//   const [loading, setLoading] = useState(true);

//   // User Info
//   const user = JSON.parse(sessionStorage.getItem('auth'));
//   const isAdmin = user?.role === 'Admin';

//   // --- FETCH DATA ---
//   const fetchRequests = async () => {
//     setLoading(true);
//     let result;

//     if (isAdmin) {
//       result = await getLeaves();
//     } else {
//       result = await getLeavesByProfile(user.id);
//     }

//     if (result.data) {
//       setRequests(result.data);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchRequests();
//   });

//   // --- CALCULATE PENDING COUNT (For Badge) ---
//   // Sirf Pending status wale count karo
//   const pendingCount = requests.filter(r => r.status === 'Pending').length;

//   // --- ADMIN ACTIONS ---
//   const handleAction = async (id, newStatus) => {
//     if (!isAdmin) return;

//     const { error } = await updateLeave(id, {
//       status: newStatus,
//       approved_by: user.id
//     });

//     if (error) {
//       alert("Error updating: " + error.message);
//     } else {
//       setRequests(prev => prev.map(req =>
//         req.id === id ? { ...req, status: newStatus } : req
//       ));
//     }
//   };

//   // --- HANDLERS ---
//   const handleFilterChange = (e) => {
//     const value = e.target.value;
//     if (value === 'Leave') setStatusFilter('all');
//     if (value === 'Pending Requests') setStatusFilter('Pending');
//     if (value === 'Approved Requests') setStatusFilter('Approved');
//     if (value === 'Rejected Requests') setStatusFilter('Rejected');
//   };

//   // Notification Click Handler: Sidha Pending filter khol dega
//   const handleNotificationClick = () => {
//     setStatusFilter('Pending');
//   };

//   const filteredRequests = requests.filter((req) => {
//     if (statusFilter === 'all') return true;
//     return req.status === statusFilter;
//   });

//   return (
//     <div className="page-container">
//       <div className="content-wrapper">

//         {/* HEADER & FILTER SECTION */}
//         <div className="filter-section">
//           <select className="filter-dropdown" onChange={handleFilterChange} value={
//             statusFilter === 'all' ? 'Leave' :
//               statusFilter === 'Pending' ? 'Pending Requests' :
//                 statusFilter === 'Approved' ? 'Approved Requests' : 'Rejected Requests'
//           }>
//             <option>Leave</option>
//             <option>Pending Requests</option>
//             <option>Approved Requests</option>
//             <option>Rejected Requests</option>
//           </select>

//           {/* ✅ NOTIFICATION BADGE (Sirf Admin ko dikhega aur agar Pending > 0 hai) */}
//           {isAdmin && pendingCount > 0 && (
//             <div className="notification-container" onClick={handleNotificationClick} title="View Pending Requests">
//               <div className="bell-icon">🔔</div>
//               <div className="notification-badge">
//                 {pendingCount > 9 ? '9+' : pendingCount}
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="data-container">
//           {loading ? <p>Loading...</p> : filteredRequests.length === 0 ? (
//             <div className="empty-state-text">No Data Found</div>
//           ) : (
//             <div className="requests-list">
//               {filteredRequests.map((req) => (
//                 <div className="request-card" key={req.id}>
//                   <div className="request-header-row">
//                     <div style={{ display: 'flex', flexDirection: 'column' }}>
//                       <span className="request-type">{req.leave_type}</span>
//                       {isAdmin && req.profiles && (
//                         <span style={{ fontSize: '12px', color: '#666' }}>
//                           By: {req.profiles.first_name} {req.profiles.last_name}
//                         </span>
//                       )}
//                     </div>

//                     <span className={`request-status-text status-${req.status.toLowerCase()}`}>
//                       {req.status}
//                     </span>
//                   </div>

//                   <div className="request-row">
//                     <span>{req.start_date} to {req.end_date}</span>
//                     <span className="request-days">{req.total_days} days</span>
//                   </div>

//                   <div className="request-reason">Reason: {req.reason}</div>

//                   {isAdmin && req.status === 'Pending' && (
//                     <div className="request-actions">
//                       <button className="approve-btn" onClick={() => handleAction(req.id, 'Approved')}>
//                         Approve
//                       </button>
//                       <button className="reject-btn" onClick={() => handleAction(req.id, 'Rejected')}>
//                         Reject
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
import { useState, useEffect } from 'react';
import '../Assests/Leave_request.css';
import { getLeaves, getLeavesByProfile, updateLeave } from '../Db_Connections/leavesApi';

export default function LeaveRequests() {
  const [requests, setRequests] = useState([]);
  const [statusFilter, setStatusFilter] = useState('Pending');
  const [loading, setLoading] = useState(true);

  // User Info
  const user = JSON.parse(sessionStorage.getItem('auth'));
  const isAdmin = user?.role === 'Admin';

  // --- FETCH DATA ---
  const fetchRequests = async () => {
    setLoading(true);
    let result;

    if (isAdmin) {
      result = await getLeaves();
    } else {
      result = await getLeavesByProfile(user.id);
    }

    if (result.data) {
      setRequests(result.data);
    }
    setLoading(false);
  };

  // ✅ yahan change kiya: [] dependency array
  useEffect(() => {
    fetchRequests();
  }, []);              // <-- iske bina har render pe API call ho rahi thi

  // --- CALCULATE PENDING COUNT (For Badge) ---
  const pendingCount = requests.filter(r => r.status === 'Pending').length;

  // --- ADMIN ACTIONS ---
  const handleAction = async (id, newStatus) => {
    if (!isAdmin) return;

    const { error } = await updateLeave(id, {
      status: newStatus,
      approved_by: user.id
    });

    if (error) {
      alert("Error updating: " + error.message);
    } else {
      setRequests(prev => prev.map(req =>
        req.id === id ? { ...req, status: newStatus } : req
      ));
    }
  };

  // --- HANDLERS ---
  const handleFilterChange = (e) => {
    const value = e.target.value;
    if (value === 'Leave') setStatusFilter('all');
    if (value === 'Pending Requests') setStatusFilter('Pending');
    if (value === 'Approved Requests') setStatusFilter('Approved');
    if (value === 'Rejected Requests') setStatusFilter('Rejected');
  };

  const handleNotificationClick = () => {
    setStatusFilter('Pending');
  };

  const filteredRequests = requests.filter((req) => {
    if (statusFilter === 'all') return true;
    return req.status === statusFilter;
  });

  return (
    <div className="page-container">
      <div className="content-wrapper">

        {/* HEADER & FILTER SECTION */}
        <div className="filter-section">
          <select
            className="filter-dropdown"
            onChange={handleFilterChange}
            value={
              statusFilter === 'all' ? 'Leave' :
              statusFilter === 'Pending' ? 'Pending Requests' :
              statusFilter === 'Approved' ? 'Approved Requests' : 'Rejected Requests'
            }
          >
            <option>Leave</option>
            <option>Pending Requests</option>
            <option>Approved Requests</option>
            <option>Rejected Requests</option>
          </select>

          {isAdmin && pendingCount > 0 && (
            <div
              className="notification-container"
              onClick={handleNotificationClick}
              title="View Pending Requests"
            >
              <div className="bell-icon">🔔</div>
              <div className="notification-badge">
                {pendingCount > 9 ? '9+' : pendingCount}
              </div>
            </div>
          )}
        </div>

        <div className="data-container">
          {loading ? (
            <p>Loading...</p>
          ) : filteredRequests.length === 0 ? (
            <div className="empty-state-text">No Data Found</div>
          ) : (
            <div className="requests-list">
              {filteredRequests.map((req) => (
                <div className="request-card" key={req.id}>
                  <div className="request-header-row">
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span className="request-type">{req.leave_type}</span>
                      {isAdmin && req.profiles && (
                        <span style={{ fontSize: '12px', color: '#666' }}>
                          By: {req.profiles.first_name} {req.profiles.last_name}
                        </span>
                      )}
                    </div>

                    <span className={`request-status-text status-${req.status.toLowerCase()}`}>
                      {req.status}
                    </span>
                  </div>

                  <div className="request-row">
                    <span>{req.start_date} to {req.end_date}</span>
                    <span className="request-days">{req.total_days} days</span>
                  </div>

                  <div className="request-reason">Reason: {req.reason}</div>

                  {isAdmin && req.status === 'Pending' && (
                    <div className="request-actions">
                      <button
                        className="approve-btn"
                        onClick={() => handleAction(req.id, 'Approved')}
                      >
                        Approve
                      </button>
                      <button
                        className="reject-btn"
                        onClick={() => handleAction(req.id, 'Rejected')}
                      >
                        Reject
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}